const manager = {
  getServices() {
    return Object.keys(this);
  },

  obtainService(service) {
    let serviceManagerElement = ''
    if (process.env.NODE_ENV == "production") {
      serviceManagerElement = this[service + "-prod"] || this[service]
    } else {
      serviceManagerElement = this[service]
    }
    return this[service]
  },

  member: 'esaleb-service-member',
  funds: 'esaleb-service-funds',
  commission: 'esaleb-service-commission',
  resource: 'esaleb-service-resource',
  tbs: 'esaleb-service-tbs',
  file: 'esaleb-service-file',
  version: 'esaleb-service-version',
  gateway: '',
  file2:'zuul/esaleb-service-file'
};


export default manager